module.exports = __webpack_public_path__ + "static/raluca-cf888ca29cee7dc466c8c9e28c076323.jpg";